import axios from 'axios'
import { returnData, config, catchError } from './api-utils'
import { createPathPrefix } from 'utils/context'

const createRole = ({ customerCode, companyCode, roleName }) =>
  axios
    .post(
      `${createPathPrefix(customerCode, companyCode, true)}roles`,
      { name: roleName },
      config()
    )
    .then(returnData)
    .catch(catchError)

const editRole = ({ customerCode, companyCode, roleId, editedRoleName }) => {
  return axios
    .patch(
      `${createPathPrefix(customerCode, companyCode, true)}roles/${roleId}`,
      { name: editedRoleName },
      config()
    )
    .then(returnData)
    .catch(catchError)
}

const copyRole = ({ customerCode, companyCode, roleId, copyRoleName }) => {
  return axios
    .post(
      `${createPathPrefix(
        customerCode,
        companyCode,
        true
      )}roles/${roleId}/copy`,
      { name: copyRoleName },
      config()
    )
    .then(returnData)
    .catch(catchError)
}

const getCompanyRoles = (customerCode, companyCode) =>
  axios
    .get(`${createPathPrefix(customerCode, companyCode, true)}roles`, config())
    .then(returnData)
    .catch(catchError)

const deleteRole = ({ customerCode, companyCode, roleId }) =>
  axios
    .delete(
      `${createPathPrefix(customerCode, companyCode, true)}roles/${roleId}`,
      config()
    )
    .then(returnData)
    .catch(catchError)

const getRolesUnderCustomer = (customerCode, includeSystemRoles) =>
  axios
    .get(
      `${createPathPrefix(
        customerCode,
        null,
        true
      )}roles/allRoles?includeSystemRoles=${includeSystemRoles}`,
      config()
    )
    .then(returnData)
    .catch(catchError)

const rolesApi = {
  createRole,
  deleteRole,
  getCompanyRoles,
  getRolesUnderCustomer,
  editRole,
  copyRole,
}

export default rolesApi
